import React from "react";
import { CalendarLogo, ClassesLogo } from "../components/logos";
const navigationConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "collapse",
    role: "PT, GT",
    icon: (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Admin-account"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="Admin-Dashboard"
            transform="translate(-32.000000, -351.000000)"
          >
            <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
              <g
                id="Dashboard-(Software-Tab)"
                transform="translate(0.000000, 248.000000)"
              >
                <g
                  id="dashboard-24px"
                  transform="translate(32.000000, 33.000000)"
                >
                  <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                  <path
                    d="M4,13 L10,13 C10.55,13 11,12.55 11,12 L11,4 C11,3.45 10.55,3 10,3 L4,3 C3.45,3 3,3.45 3,4 L3,12 C3,12.55 3.45,13 4,13 Z M4,21 L10,21 C10.55,21 11,20.55 11,20 L11,16 C11,15.45 10.55,15 10,15 L4,15 C3.45,15 3,15.45 3,16 L3,20 C3,20.55 3.45,21 4,21 Z M14,21 L20,21 C20.55,21 21,20.55 21,20 L21,12 C21,11.45 20.55,11 20,11 L14,11 C13.45,11 13,11.45 13,12 L13,20 C13,20.55 13.45,21 14,21 Z M13,4 L13,8 C13,8.55 13.45,9 14,9 L20,9 C20.55,9 21,8.55 21,8 L21,4 C21,3.45 20.55,3 20,3 L14,3 C13.45,3 13,3.45 13,4 Z"
                    id="Shape"
                    fill="#8700A9"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    navLink: "/trainer-panel/dashboard",
  },
  {
    id: "members",
    title: "Members",
    type: "item",
    role: "PT, GT",
    icon: (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Gym-Admin"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.5"
        >
          <g id="Gym-Info" transform="translate(-32.000000, -515.000000)">
            <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
              <g id="Users" transform="translate(0.000000, 434.000000)">
                <g
                  id="assignment_ind-24px"
                  transform="translate(32.000000, 11.000000)"
                >
                  <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                  <path
                    d="M19,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L5,3 C3.9,3 3,3.9 3,5 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M12,2.75 C12.22,2.75 12.41,2.85 12.55,3 C12.67,3.13 12.75,3.31 12.75,3.5 C12.75,3.91 12.41,4.25 12,4.25 C11.59,4.25 11.25,3.91 11.25,3.5 C11.25,3.31 11.33,3.13 11.45,3 C11.59,2.85 11.78,2.75 12,2.75 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z M12,6 C10.35,6 9,7.35 9,9 C9,10.65 10.35,12 12,12 C13.65,12 15,10.65 15,9 C15,7.35 13.65,6 12,6 Z M12,10 C11.45,10 11,9.55 11,9 C11,8.45 11.45,8 12,8 C12.55,8 13,8.45 13,9 C13,9.55 12.55,10 12,10 Z M6,16.47 L6,18 L18,18 L18,16.47 C18,13.97 14.03,12.89 12,12.89 C9.97,12.89 6,13.96 6,16.47 Z M8.31,16 C9,15.44 10.69,14.88 12,14.88 C13.31,14.88 15.01,15.44 15.69,16 L8.31,16 Z"
                    id="Shape"
                    fill="#000000"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    navLink: "/trainer-panel/memberslist",
  },
  {
    id: "schedule",
    title: "Schedule",
    type: "item",
    role: "PT, GT",
    icon: <CalendarLogo width="24" color={"#999999"} />,
    navLink: "/trainer-panel/schedule",
  },
  {
    id: "info",
    title: "Info",
    type: "item",
    role: "PT, GT",
    icon: (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>6AB99C0B-0DAC-41B6-B748-720E6DDEBA3A</title>
        <g
          id="Admin-account"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.5"
        >
          <g
            id="Admin-Dashboard"
            transform="translate(-32.000000, -543.000000)"
          >
            <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
              <g id="Info" transform="translate(0.000000, 462.000000)">
                <g
                  id="person-24px-(2)"
                  transform="translate(32.000000, 11.000000)"
                >
                  <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                  <path
                    d="M12,12 C14.21,12 16,10.21 16,8 C16,5.79 14.21,4 12,4 C9.79,4 8,5.79 8,8 C8,10.21 9.79,12 12,12 Z M12,14 C9.33,14 4,15.34 4,18 L4,19 C4,19.55 4.45,20 5,20 L19,20 C19.55,20 20,19.55 20,19 L20,18 C20,15.34 14.67,14 12,14 Z"
                    id="Shape"
                    fill="#000000"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    navLink: "/trainer-panel/trainerinfo",
  },
  // {
  //   id: "notification",
  //   title: "Notifications",
  //   type: "item",
  //   role: "PT, GT",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 25 32"
  //     >
  //       <g>
  //         <g>
  //           <path
  //             fill="#FF9E00"
  //             d="M8.508 27.817v.025a3.745 3.745 0 1 0 7.49 0v-.025z"
  //           ></path>
  //         </g>
  //         <g>
  //           <path
  //             fill="#FF9E00"
  //             d="M24.21 23.136l-3.37-4.951v-6.178a8.59 8.59 0 0 0-6.903-8.421V1.684a1.684 1.684 0 0 0-3.368 0v1.902a8.59 8.59 0 0 0-6.903 8.421v6.178l-3.37 4.951a1.703 1.703 0 0 0 1.407 2.66h21.1a1.703 1.703 0 0 0 1.407-2.66z"
  //           ></path>
  //         </g>
  //       </g>
  //     </svg>
  //   ),
  //   navLink: "/trainer-panel/notification",
  // },
  {
    id: "setting-privacy",
    title: "Settings",
    type: "item",
    role: "PT, GT",
    icon: (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Gym-Admin"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          opacity="0.5"
        >
          <g id="Gym-Info" transform="translate(-32.000000, -731.000000)">
            <g id="Side-Menu" transform="translate(0.000000, 70.000000)">
              <g id="Appointments" transform="translate(0.000000, 650.000000)">
                <g
                  id="lock-24px-(1)"
                  transform="translate(32.000000, 11.000000)"
                >
                  <g id="Group">
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                    <polygon
                      id="Path"
                      opacity="0.87"
                      points="0 0 24 0 24 24 0 24"
                    ></polygon>
                  </g>
                  <path
                    d="M18,8 L17,8 L17,6 C17,3.24 14.76,1 12,1 C9.24,1 7,3.24 7,6 L7,8 L6,8 C4.9,8 4,8.9 4,10 L4,20 C4,21.1 4.9,22 6,22 L18,22 C19.1,22 20,21.1 20,20 L20,10 C20,8.9 19.1,8 18,8 Z M12,17 C10.9,17 10,16.1 10,15 C10,13.9 10.9,13 12,13 C13.1,13 14,13.9 14,15 C14,16.1 13.1,17 12,17 Z M9,8 L9,6 C9,4.34 10.34,3 12,3 C13.66,3 15,4.34 15,6 L15,8 L9,8 Z"
                    id="Shape"
                    fill="#000000"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    navLink: "/trainer-panel/settings",
  },
];

export default navigationConfig;
